import React from 'react';
import classNames from 'classnames';
import ToolbarStyles from './toolbar.less';

const baseClass = ToolbarStyles.easToolbar;

module.exports = React.createClass({
  propTypes: {
    className: React.PropTypes.string,
    actions: React.PropTypes.array
  },
  getClass(){
    return classNames(this.props.className, baseClass);
  },
  render(){
    return(
      <div className={this.getClass()}>
        {this.props.children.map(function(child){
          return (<span className={ToolbarStyles.easToolbarItem}>{child}</span>);
        })}
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/toolbar/toolbar/index.js
 **/